import { baseMbList } from "./config";

window.onload = function () {
  getRem(750, 100)
  const arr = baseMbList.filter((item) => {
    return window.location.pathname == item.path;
  });
  if (arr.length > 0 && arr[0].isUmeng) {
    (function (w, d, s, q, i) {
      w[q] = w[q] || [];
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s);
      j.async = true;
      j.id = "beacon-aplus";
      j.src = "https://d.alicdn.com/alilog/mlog/aplus/" + i + ".js";
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "aplus_queue", "203467608");
    // 集成应用的appKey
    aplus_queue.push({
      action: "aplus.setMetaInfo",
      arguments: ["appKey", arr[0].isUmeng],
    });
  }
};
window.onresize = function () {
  getRem(750, 100)
};
function getRem(pwidth, prem) {
  var html = document.getElementsByTagName("html")[0];
  var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
  html.style.fontSize = oWidth / pwidth * prem + "px";
}